var exports = {
  "container": "x31de4314--24e367--container",
  "icon": "x31de4314--24e367--icon",
  "villages": "x31de4314--24e367--villages",
  "builders": "x31de4314--24e367--builders",
  "text": "x31de4314--24e367--text",
  "title": "x31de4314--24e367--title",
  "arrow": "x31de4314--24e367--arrow",
};

module.exports = exports;
